import REGEX from './regex.js';
function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}
export default validate;


// WEBPACK FOOTER //
// ./node_modules/@snowplow/browser-plugin-site-tracking/node_modules/uuid/dist/esm-browser/validate.js